// extracted by mini-css-extract-plugin
module.exports = {"nesting-swiper":"NestingSwiper_nesting-swiper__s2j97"};